import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import {ScoringEffects} from './effects/scoring.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('scoringState', reducers),
    EffectsModule.forFeature([
      ScoringEffects
    ])
  ]
})
export class ScoringStoreModule {}
